// import { Base64 } from "js-base64";

const goDial = (telNum) => {
  // thinq
  // if (window.NativeInterface && window.NativeInterface.open) window.NativeInterface.open("tel:" + telNum);
  // else window.open("tel:" + telNum);
  window.open('tel:' + telNum, '_parent'); // safari에서 _parent가 없으면 전화결면서 새로운 창이 열림
};

const getLGEURL = (url = '') => {
  const isHTLS = url.indexOf('htls') >= 0; // 배송htls (http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06467C5AA72B720EB9%7CTALK) 주소는 lge.co.kr이라도 inapp으로 열지 않는다
  if (isHTLS) {
    return '';
  } else {
    const matches = /(?:https?:\/\/)?(\w+)\.(lge.co.kr)/.exec(url);
    return matches && matches[2];
  }
};

const openLinkIOS = (linkType, url) => {
  linkType = linkType.toLowerCase();
  let obj = {}; //new Object();

  if (getLGEURL(url) || linkType === 'inapp') {
    obj.command = 'openInAppBrowser';

    if (url.includes('account')) {
      // iOS 회원 로그인시 bottombar 제거 요청 24-11
      obj.bottombar_show = 'N';
    } else {
      obj.bottombar_show = 'Y';
    }
  } else {
    //if (linkType === "external"){
    obj.command = 'openLinkOut';
  }
  obj.url = url;
  let jsonString = JSON.stringify(obj);
  if (window.webkit) {
    window.webkit.messageHandlers.callbackHandler.postMessage(jsonString);
  } else {
    throw new Error('[openLinkIOS] No webkit object is exist');
  }
};

const openLinkAndroid = (linkType, url) => {
  linkType = linkType.toLowerCase();
  if (!window.android) {
    throw new Error('[openLinkAndroid] No android object is exist');
  }
  if (getLGEURL(url) || linkType === 'inapp') {
    window.android.openNewWebview(url);
  } else {
    //if (linkType === "external"){
    window.android.openLinkOut(url);
  }
};

const openLink = (
  context,
  linkType,
  url,
  log = null,
  newWindow = false,
  windowObj = null
) => {
  const osName = context.userAgent.os.toLowerCase();
  const deviceType = context.userAgent.deviceType;
  const isLGEAPP = context.userAgent.isLGEAPP;

  console.log(`[openLink] LGEAPP:${isLGEAPP}, LGEURL:${getLGEURL(url)}`);
  console.log('>> openLink', deviceType, url, linkType);

  if (deviceType === 'mobile') {
    if (linkType === 'phone') {
      // 구독 추천 시나리오의 구독 카드 전화 상담 예약 버튼 추가 25-02
      // if (url.includes('request-call-reservation') && url.includes('rentalCare=y')) {
      //   window.open(url);
      // } else {
      // [개선] 모바일 "전화 상담 예약" > "전화 상담" 25-03
      goDial(url);
      // }
    } else if (isLGEAPP) {
      if (osName === 'ios') {
        openLinkIOS(linkType, url);
      } else if (osName === 'android') {
        openLinkAndroid(linkType, url);
      } else {
        throw new Error(`[openLink] not supported OS`);
      }
    } else {
      if (windowObj) {
        windowObj.location.href = url;
      } else {
        window.open(url);
      }
    }
  } else {
    if (newWindow) {
      window.open(
        url,
        '',
        `width=${window.outerWidth},height=${window.outerHeight},top=${window.screenTop},left=${window.screenLeft}`
      );
    } else {
      if (windowObj) {
        windowObj.location.href = url;
      } else {
        window.open(url);
      }
    }
  }

  if (log) {
    context.log(context, 'clicks', log);
  }
};

const closeIOS = () => {
  let obj = { command: 'closeInAppBrowser' };
  let jsonString = JSON.stringify(obj);
  if (window.webkit) {
    // alert('window.webkit 11111');
    window.webkit.messageHandlers.callbackHandler.postMessage(jsonString);
  } else {
    // alert('22222');
    window.close();
  }
};

const closeAndroid = () => {
  if (window.android) {
    window.android.closeNewWebview();
  } else {
    window.close();
  }
};

const closeChatbot = (context) => {
  const osName = context.userAgent.os.toLowerCase();
  const deviceType = context.userAgent.deviceType;
  const isLGEAPP = context.userAgent.isLGEAPP;
  if (deviceType === 'mobile' && isLGEAPP) {
    if (osName === 'ios') {
      closeIOS();
    } else if (osName === 'android') {
      closeAndroid();
    } else {
      throw new Error(`[openLink] not supported OS`);
    }
  } else {
    window.close();
  }
};

const shareApi = (context, title, text, url) => {
  const osName = context.userAgent.os.toLowerCase();
  const deviceType = context.userAgent.deviceType;
  const isLGEAPP = context.userAgent.isLGEAPP;

  if (deviceType === 'mobile') {
    if (isLGEAPP) {
      if (osName === 'ios') {
        let obj = { command: 'share', url };
        if (title) obj.title = title;
        if (text) obj.text = text;
        let jsonString = JSON.stringify(obj);
        if (window.webkit) {
          window.webkit.messageHandlers.callbackHandler.postMessage(jsonString);
        }
      } else if (osName === 'android') {
        if (window.android) {
          window.android.share(title || '', text || '', url);
        }
      }
    } else if (window.navigator.share) {
      const obj = { url };
      if (title) obj.title = title;
      if (text) obj.text = text;
      window.navigator
        .share(obj)
        .then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.log);
    }
  } else {
    console.log('not supported device for share api');
  }
};

export { goDial, openLink, closeChatbot, shareApi };
